import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { LoaderService } from '../../services/loader.service'

@Component({
    selector: 'app-loader-spinner',
    templateUrl: './loader-spinner.component.html',
    styleUrls: ['./loader-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderSpinnerComponent implements OnInit {
    isLoading: boolean = false
    isBlocked: boolean = false

    constructor(
        private loaderService: LoaderService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.loaderService.isLoading.subscribe((status) => {
            this.isLoading = status
            this.cdr.detectChanges()
        })
        this.loaderService.blockSubmit.subscribe((status) => {
            this.isBlocked = status
            this.cdr.detectChanges()
        })
    }
}
